import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import Bowser from 'bowser';
/**
 * Checks if user agent matches supported browsers.
 *
 * @param {*} userAgent
 * @param {*} supportedBrowsers
 */

export function checkBrowserSupport(userAgent, supportedBrowsers) {
  var _context;

  if (!supportedBrowsers) {
    return false;
  }

  var browser = Bowser.getParser(userAgent);
  return browser.satisfies(_reduceInstanceProperty(_context = _Object$keys(supportedBrowsers)).call(_context, function (accumulator, key) {
    return _Object$assign({}, accumulator, _defineProperty({}, key, '>=0'));
  }, {}));
}
/**
 * Checks if user agent matches supported browser versions.
 *
 * @param {*} userAgent
 * @param {*} supportedBrowsers
 */

export function checkVersionSupport(userAgent, supportedBrowsers) {
  if (!supportedBrowsers) {
    return false;
  }

  var browser = Bowser.getParser(userAgent);
  return browser.satisfies(supportedBrowsers);
}
/**
 * Utilities related to the use of Browser support features.
 * @export
 * @class BrowserSupportUtils
 */

var BrowserSupportUtils =
/** */
function BrowserSupportUtils(supportedBrowsers) {
  _classCallCheck(this, BrowserSupportUtils);

  this.userAgent = navigator.userAgent;
  this.supportedBrowsers = supportedBrowsers;
  this.browserSupport = checkBrowserSupport(this.userAgent, this.supportedBrowsers);
  this.versionSupport = checkVersionSupport(this.userAgent, this.supportedBrowsers);
};

export default BrowserSupportUtils;